export interface InsuredOpportunityQuoteLike {
  policy?: unknown | null;
}

export interface InsuredOpportunitySubmissionLike {
  quotes?: readonly InsuredOpportunityQuoteLike[] | null;
}

export interface InsuredOpportunityLike {
  renewalOfPolicies?: readonly unknown[] | null;
  submissions?: readonly InsuredOpportunitySubmissionLike[] | null;
}

export interface ClassifiedInsuredOpportunities<TOpportunity extends InsuredOpportunityLike> {
  losts: TOpportunity[];
  renewals: TOpportunity[];
  wons: TOpportunity[];
}

export const classifyInsuredOpportunities = <TOpportunity extends InsuredOpportunityLike>({
  opportunities,
}: {
  opportunities?: readonly TOpportunity[] | null;
}): ClassifiedInsuredOpportunities<TOpportunity> => {
  const insuredOpportunities = [...(opportunities ?? [])];

  return {
    renewals: insuredOpportunities.filter((opportunity) => (opportunity.renewalOfPolicies?.length ?? 0) > 0),
    wons: insuredOpportunities.filter((opportunity) =>
      opportunity.submissions?.some((submission) => submission.quotes?.some((quote) => quote.policy !== null))
    ),
    losts: insuredOpportunities.filter((opportunity) => {
      const hasQuotes = opportunity.submissions?.some((submission) => (submission.quotes?.length ?? 0) > 0);
      const hasNoPolicy = opportunity.submissions?.every((submission) =>
        submission.quotes?.every((quote) => quote.policy === null)
      );

      return hasQuotes && hasNoPolicy;
    }),
  };
};
